import mobileMenu from 'assets/mobile-menu.svg';
import Image from 'next/image';

const HamburgerIcon = ({ onClick }) => {
  return <Image src={mobileMenu} alt="mobile-menu-icon" onClick={onClick} />;
};

export default HamburgerIcon;
